import React from 'react';

const Actions = ({ children }) => {
  return <div className='actions'>{children}</div>;
};

export default Actions;
